/**
 * Middleware to normalize country/locale in route paths.
 *
 * @param {Object} to - The route being navigated to
 * @param {string} to.fullPath - Full path of the destination route
 *
 * @returns {void|NavigationResponse} Redirects to lowercase route if needed
 *
 * @description
 * - Skips normalization if the application is federated
 * - Checks if the first segment of the path (country/locale) is lowercase
 * - Redirects to the lowercase version of the path if it contains uppercase characters
 *
 * @remarks
 * - Ensures consistent routing by enforcing lowercase country/locale segments
 * - Prevents routing inconsistencies due to case variations
 *
 * @example
 * For route '/EN/products'
 *  Redirects to '/en/products'
 *
 * For route '/US/cart'
 *  Redirects to '/us/cart'
 */
export default defineNuxtRouteMiddleware(to => {
  if (useRuntimeConfig().public.isFederated) return
  const countryLocale = to.fullPath.split('/')[1]
  // check if countryLocale is not lowercase
  if (countryLocale !== countryLocale.toLowerCase()) {
    return navigateTo(to.fullPath.toLowerCase())
  }
})
